/** Persists UI light/dark choice for all routes (see root layout + ExpiryDeskApp toggle). */
export const THEME_STORAGE_KEY = "expirydesk-ui-theme";

const LEGACY_BLOG_THEME_KEY = "expirydesk_blog_theme";

export function readPreferredColorScheme(): "light" | "dark" {
  if (typeof window === "undefined") return "light";
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
    const legacy = localStorage.getItem(LEGACY_BLOG_THEME_KEY);
    if (legacy === "dark" || legacy === "light") {
      localStorage.setItem(THEME_STORAGE_KEY, legacy);
      return legacy;
    }
  } catch {
    /* private mode */
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function syncBlogRootNodes(isDarkMode: boolean): void {
  const t = isDarkMode ? "dark" : "light";
  document.querySelectorAll(".ed-blog-root").forEach((el) => {
    el.setAttribute("data-blog-theme", t);
  });
}

export function applyDocumentThemePreference(isDarkMode: boolean): void {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.edTheme = isDarkMode ? "dark" : "light";
  try {
    localStorage.setItem(THEME_STORAGE_KEY, isDarkMode ? "dark" : "light");
  } catch {
    /* private mode */
  }
  syncBlogRootNodes(isDarkMode);
  if (typeof window !== "undefined") {
    try {
      window.dispatchEvent(new CustomEvent("expirydesk-theme-change"));
    } catch {
      /* ignore */
    }
  }
}
